var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef } from '@angular/core';
import { DomManipulationService } from './dom-manipulation.service';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
var BrowserDomManipulationService = /** @class */ (function (_super) {
    __extends(BrowserDomManipulationService, _super);
    function BrowserDomManipulationService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._scriptMap = {};
        return _this;
    }
    BrowserDomManipulationService.prototype.loadScript = function (script) {
        var _this = this;
        if (!this._scriptMap[script.id]) {
            this._scriptMap[script.id] = new BehaviorSubject(false);
            var node = document.createElement('script');
            node.id = script.id;
            node.src = script.src;
            node.type = 'text/javascript';
            node.async = script.async;
            node.charset = 'utf-8';
            if (!script.globalCallback) {
                node.onload = function () { return _this._scriptMap[script.id].next(true); };
            }
            else {
                window[script.globalCallback] = function () { return _this._scriptMap[script.id].next(true); };
            }
            document.getElementsByTagName('head')[0].appendChild(node);
        }
        return this._scriptMap[script.id].pipe(filter(function (s) { return !!s; }));
    };
    BrowserDomManipulationService.prototype.removeElementById = function (scriptId) {
        var el = document.getElementById(scriptId);
        if (el) {
            el.parentNode.removeChild(el);
        }
        if (!!this._scriptMap[scriptId]) {
            this._scriptMap[scriptId].complete();
            delete this._scriptMap[scriptId];
        }
    };
    BrowserDomManipulationService.prototype.focus = function (element) {
        element.nativeElement.focus();
    };
    BrowserDomManipulationService.prototype.blur = function (element) {
        element.nativeElement.blur();
    };
    BrowserDomManipulationService.prototype.querySelectorAndSetInnerHTML = function (elementRef, querySelector, text) {
        elementRef.nativeElement.querySelector(querySelector).innerHTML = text;
    };
    BrowserDomManipulationService.prototype.scrollIntoView = function (element, top) {
        if (element)
            element.nativeElement.scrollIntoView();
        // element.nativeElement.scrollIntoView({ block: 'start', behavior: 'smooth'});
    };
    BrowserDomManipulationService.prototype.scrollToTop = function (elementRef) {
        if (elementRef && elementRef.nativeElement) {
            elementRef.nativeElement.scrollTop = 0; // For Chrome, Safari and Opera
        }
        else {
            document.body.scrollTop = 0; // For Chrome, Safari and Opera
            document.documentElement.scrollTop = 0; // For IE and Firefox
        }
    };
    BrowserDomManipulationService.prototype.scrollTo = function (x, y) {
        window.scrollTo(x, y);
    };
    BrowserDomManipulationService.prototype.querySelectorContent = function (querySelector, description) {
        document.querySelector(querySelector).textContent = description;
    };
    BrowserDomManipulationService.prototype.querySelector = function (element, selector) {
        return element.nativeElement.querySelector(selector);
    };
    BrowserDomManipulationService.prototype.documentQuerySelectorHeight = function (selector) {
        return document.querySelector(selector).scrollHeight;
    };
    BrowserDomManipulationService.prototype.runFunctionWithTimeout = function (func, timeout) {
        setTimeout(func, timeout);
    };
    return BrowserDomManipulationService;
}(DomManipulationService));
export { BrowserDomManipulationService };
